import axios from "axios";
export const HTTP = axios.create({
    baseURL:window.VUE_CONFIG_API,
})

export const HTTPImage = axios.create({
    baseURL:window.VUE_CONFIG_API_IMAGE,
})

// Guest user credentials for eCommerce API access
// These should be environment-specific and configured per deployment
// Format: userId|userKey as expected by GetAdminUserFromRequest
const getGuestCredentials = () => {
    // Use environment-specific guest credentials
    const guestUser = window.ECOMMERCE_GUEST_USER || 'ecommerce_guest'
    const guestKey = window.ECOMMERCE_GUEST_KEY || 'guest_readonly_key'
    return `${guestUser}|${guestKey}`
}

// Only set guest credentials if no user is logged in
const setGuestCredentials = () => {
    const guestCreds = getGuestCredentials()
    HTTP.defaults.headers.post['adminuser'] = guestCreds
    HTTPImage.defaults.headers.post['adminuser'] = guestCreds
}

// Initialize with guest credentials
setGuestCredentials()

// Export function to update credentials when user logs in
export const updateApiCredentials = (userCredentials = null) => {
    if (userCredentials) {
        // User is logged in - use their credentials
        HTTP.defaults.headers.post['adminuser'] = `${userCredentials.userId}|${userCredentials.userKey}`
        HTTPImage.defaults.headers.post['adminuser'] = `${userCredentials.userId}|${userCredentials.userKey}`
    } else {
        // User logged out - revert to guest credentials
        setGuestCredentials()
    }
}